var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "root-porpos" }, [
    _c(
      "div",
      [
        _vm._m(0),
        _c(
          "el-form",
          {
            ref: "darfForm",
            attrs: {
              model: _vm.form,
              rules: _vm.rules,
              "label-position": "top"
            }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "合同名称:", prop: "docName" } },
              [
                _c("el-input", {
                  staticStyle: { width: "450px" },
                  attrs: { placeholder: "请输入合同名称" },
                  model: {
                    value: _vm.form.docName,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "docName", $$v)
                    },
                    expression: "form.docName"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "合同文件:", prop: "docFile" } },
              [
                _c(
                  "div",
                  { staticClass: "file-list" },
                  [
                    _c(
                      "draggable",
                      {
                        staticClass: "file-draggable",
                        attrs: {
                          element: "ul",
                          list: _vm.fileList,
                          options: {
                            handle: ".icon-move_box",
                            animation: 200,
                            ghostClass: "ghost"
                          },
                          filter: ".upload-btn"
                        },
                        on: {
                          start: function($event) {
                            _vm.dragging = true
                          },
                          end: function($event) {
                            _vm.dragging = false
                          }
                        }
                      },
                      [
                        _vm._l(_vm.fileList, function(file, index) {
                          return [
                            _c(
                              "transition-group",
                              { key: index, attrs: { type: "transition" } },
                              [
                                _c(
                                  "li",
                                  { key: index, staticClass: "upload-file" },
                                  [
                                    _c("div", { staticClass: "bx" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.fileSuffix(file.fileName)
                                        }
                                      }),
                                      _c("div", { staticClass: "msk" }, [
                                        _c("div", { staticClass: "msk-icon" }, [
                                          _c("i", {
                                            staticClass: "el-icon-view",
                                            on: {
                                              click: function($event) {
                                                return _vm.previewDoc(file)
                                              }
                                            }
                                          }),
                                          _c("i", {
                                            staticClass: "el-icon-delete-solid",
                                            on: {
                                              click: function($event) {
                                                return _vm.removeFile(
                                                  index,
                                                  file
                                                )
                                              }
                                            }
                                          })
                                        ])
                                      ])
                                    ]),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "title",
                                        attrs: { title: file.fileName }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(file.fileName) +
                                            "\n                  "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "icon-move_box" },
                                      [_c("i")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.fileList.length === 0,
                                expression: "fileList.length === 0"
                              }
                            ],
                            staticClass: "upload-btn"
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "#",
                                  limit: 1,
                                  "show-file-list": false,
                                  "on-exceed": _vm.exceed,
                                  accept: ".doc,.docx",
                                  "before-upload": _vm.fileUpload,
                                  "file-list": _vm.fileList
                                }
                              },
                              [
                                _vm._t("default", function() {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "upload-content" },
                                      [
                                        _c("span", {
                                          staticClass: "el-icon-plus"
                                        }),
                                        _c("p", { staticClass: "tip" }, [
                                          _vm._v("上传 doc、docx 格式文件,"),
                                          _c("br"),
                                          _vm._v("且不超过 30M!")
                                        ])
                                      ]
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            ),
            _c("el-form-item", { attrs: { label: "拟定人员", required: "" } }, [
              _c(
                "div",
                { staticClass: "propos-box" },
                _vm._l(_vm.propos, function(item, i) {
                  return _c(
                    "el-form",
                    {
                      key: i,
                      ref: "drafUseForm",
                      refInFor: true,
                      staticStyle: { "margin-bottom": "2vh" },
                      attrs: { model: item, inline: "" }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "合同拟定方" + (i + 1) + ": ",
                            prop: "phoneOrEmail",
                            rules: _vm.propRule
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { "padding-left": "15px" },
                            attrs: {
                              clearable: "",
                              placeholder: "请输入邮箱/手机号"
                            },
                            on: {
                              input: function($event) {
                                return _vm.partAdd(i, $event)
                              }
                            },
                            model: {
                              value: item.phoneOrEmail,
                              callback: function($$v) {
                                _vm.$set(item, "phoneOrEmail", $$v)
                              },
                              expression: "item.phoneOrEmail"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "名称: ",
                            prop: "userName",
                            rules: [
                              {
                                required: true,
                                message: "请输入名称",
                                trigger: "blur"
                              }
                            ]
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { "padding-left": "15px" },
                            attrs: { placeholder: "请输入名称" },
                            model: {
                              value: item.userName,
                              callback: function($$v) {
                                _vm.$set(item, "userName", $$v)
                              },
                              expression: "item.userName"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c("div", { staticClass: "propos-action" }, [
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.propos.length - 1 > 0,
                                expression: "propos.length - 1 > 0"
                              }
                            ],
                            staticStyle: { "margin-right": "20px" },
                            attrs: {
                              src: "/images/AISmart/icon/del.png",
                              alt: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.delItem(item)
                              }
                            }
                          }),
                          _c("img", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.propos.length - 1 == i,
                                expression: "propos.length - 1 == i"
                              }
                            ],
                            attrs: {
                              src: "/images/AISmart/icon/puls.png",
                              alt: ""
                            },
                            on: { click: _vm.addItem }
                          })
                        ])
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            ]),
            _c(
              "el-form-item",
              { staticClass: "submit-btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { plain: "" },
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v("返回")]
                ),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.drafStart } },
                  [_vm._v("立即发起协作")]
                )
              ],
              1
            )
          ],
          1
        ),
        _c("view-files-to-doc", {
          attrs: {
            visibleShow: _vm.visibleShowEnclosureDoc,
            enclosurePreviewNumItem: _vm.enclosurePreviewNumItem
          },
          on: { setViewFilesToDocDialogData: _vm.onSetViewFilesToDocDialogData }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "icon-title" }, [
      _c("span", { staticClass: "paragraph-icon" }),
      _vm._v("合同起草")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bc5e7b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc5e7b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/smartContract/proposed.vue
// module id = rxzy
// module chunks = 146